import { useState } from "react";
import { toast } from "sonner";
import { downloadFile, errText } from "../../lib/api";
import { DownloadSimple, UsersThree, CalendarCheck, AirplaneTilt } from "@phosphor-icons/react";
import { DigestPanel } from "../../components/admin/reports/DigestPanel";

const thisMonth = () => new Date().toISOString().slice(0, 7);

export default function Reports() {
  const [month, setMonth] = useState(thisMonth());

  const dl = (path, name) => downloadFile(path, name).then(() => toast.success("Report downloaded")).catch((e) => toast.error(errText(e)));

  const cards = [
    { icon: UsersThree, title: "Employee master", desc: "Full directory with codes, departments, roles and status.", action: () => dl("/reports/employees", "employee_master.csv"), testId: "report-employees" },
    { icon: CalendarCheck, title: "Attendance report", desc: `Daily punches, hours and overtime for ${month}.`, action: () => dl(`/reports/attendance?month=${month}`, `attendance_${month}.csv`), testId: "report-attendance" },
    { icon: AirplaneTilt, title: "Leave report", desc: "All leave requests with status and reviewer.", action: () => dl("/reports/leave", "leave_report.csv"), testId: "report-leave" },
  ];

  return (
    <div className="space-y-8 max-w-5xl" data-testid="reports-page">
      <div>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight">Reports</h1>
        <p className="text-stone-500 text-sm mt-1">Monthly digest and CSV downloads. Statutory exports (PF / ESIC / TDS) live on the Payroll page.</p>
      </div>

      <DigestPanel />

      <div>
        <label className="text-sm font-semibold text-stone-700">Report month (attendance)</label>
        <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="report-month-input"
          className="mt-1 block min-h-[44px] px-3 rounded-lg border border-stone-300 bg-white" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => (
          <div key={c.title} className="bg-white border border-stone-200 rounded-lg p-6 flex flex-col gap-3 hover:shadow-sm transition-shadow duration-200">
            <c.icon size={26} weight="duotone" className="text-primary" />
            <div className="font-heading font-bold">{c.title}</div>
            <p className="text-sm text-stone-500 flex-1">{c.desc}</p>
            <button onClick={c.action} data-testid={c.testId}
              className="tap-scale flex items-center justify-center gap-2 min-h-[44px] rounded-full bg-secondary text-white text-sm font-bold hover:bg-[#1E2B22] transition-colors duration-200">
              <DownloadSimple size={16} /> Download CSV
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
